import axios from "axios";

import { basePath, createHeaders } from "./utils";

/**
 * GET
 * /api/equipment/types
 * 
 * Returns all equipment types
 */
export const getEquipmentTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/equipment/types`, config)
      .then((resp) => {
        console.log("getEquipmentTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/equipment/statuslog/{equipmentId: string($uuid)}
 * ?fromDttm={from: string($date-time)}
 * &toDttm={to: string($date-time)}
 * 
 * Returns all status log entries for an equipment id
 */
export const getStatusLogsByEquipmentId = (equipmentId, from, to) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/equipment/statuslog/${equipmentId}&from=${from}&to=${to}`, config)
      .then((resp) => {
        console.log("getStatusLogsByEquipmentId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      })
  });
};

/**
 * GET
 * /api/equipment/status/types
 * 
 * Returns all equipment status types
 */
export const getEquipmentStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/equipment/status/types`, config)
      .then((resp) => {
        console.log("getEquipmentStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      })
  });
};
